import { Component, computed, input } from '@angular/core';

import { UpdateTimeComponent } from '@shared/components';
import { Annunciation } from '@shared/models';
import { ColumnRendererComponentV3 } from '@gea/digital-ui-lib';

import { ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'gea-hrt-last-instance-renderer',
  imports: [UpdateTimeComponent],
  template: `
    @if (rowData()) {
      <div>
        @let value = this.value();
        @if (value) {
          <gea-hrt-update-time [date]="value" [format]="'dd/MM/yyyy HH:mm:ss'" />
        }
        @if (!value) {
          <span>—</span>
        }
      </div>
    }
  `,
})
export class LastInstanceRendererComponent implements ColumnRendererComponentV3<Annunciation> {
  readonly rowData = input<Annunciation>();
  readonly columnKey = input<string>('timeStamp');

  readonly value = computed((): string | Date | null | undefined => {
    const v = this.rowData()?.[this.columnKey()] as string | number | Date | null | undefined;
    if (typeof v === 'number') {
      return new Date(v);
    }
    if (typeof v === 'string') {
      return new Date(v);
    }
    return v as string | Date | null | undefined;
  });
}
